<template>
  <div class="speedStudyPage">
    <div>
      <van-pull-refresh
        style="min-height: 100vh"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="selfStudy">
            <Navbar
              :title="courseObj.name"
              :backNative="true"
              v-if="showTitle"
              style="position: absolute; top: 0; z-index: 9999"
              class="topNav"
            />

            <div class="bg">
              <img
                @click="toNative"
                :style="{ top: statusHeight + 'px' }"
                src="../../assets/images/backIcon.png"
                alt=""
              />
              <div class="courseType">
                <div class="typeInfo" ref="scrollOne">
                  <div class="typeTitle">{{ courseObj.name }}</div>
                  <div class="typeword">{{ courseObj.title }}</div>
                </div>
              </div>
            </div>

            <div class="content">
              <div class="buyContent">
                <div class="areadlyBuy" @click="toBuyedPage">
                  <div class="buyedTitle">已购课程</div>
                  <img src="../../assets/images/right.png" alt="" />
                </div>

                <div
                  class="buyedList"
                  v-if="alreadyBoughtCourseList.length == 0"
                >
                  <img
                    class="notHave"
                    src="../../assets/images/reading.png"
                    alt=""
                  />
                  <span>暂无已购课程，快去购买课程吧~</span>
                </div>

                <div class="buyedList2" v-else>
                  <div
                    class="buyedCourse"
                    @click="toLearn(item.id)"
                    v-for="(item, index) in alreadyBoughtCourseList"
                    :key="index"
                  >
                    <img :src="item.cover" alt="" />
                    <div>{{ item.name }}</div>
                  </div>
                </div>
              </div>

              <div class="contentTitle">最新课程</div>
              <div class="intro">官方推荐丨总有适合你的一款</div>
              <div class="courseList">
                <div
                  class="courseCard"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div class="coursePoster">
                    <img :src="item.cover" alt="" />
                  </div>

                  <div class="cardRight">
                    <div class="courseTitle">{{ item.name }}</div>
                    <div class="learnNum">{{ item.title }}</div>

                    <div class="courseBt">
                      <div class="teacherInfo">
                        <img :src="item.teacherAvatar" alt="" />
                        <div class="teachername">{{ item.teacherName }}</div>
                      </div>

                      <div class="learnBt" @click="toLearn(item.id)">
                        开始学习
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
import { Toast } from "vant";
export default {
  data() {
    return {
      showTitle: false,
      list: [], //最新课程
      alreadyBoughtCourseList: [], //已购课程
      loading: false, //是否正在加载
      finished: false, //是否结束
      refreshing: false, //是否正在刷新
      courseObj: {}, //课程数据
      current: 1,
      size: 20,
      init: false,
      lit: 1,
      num:1
    };
  },
  components: {
    Navbar,
  },
  activated() {
    setTimeout(() => {
      if (this.Init) {
        this.initPage();
      }
    }, 200);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.Init) {
          this.initPage();
        }
      }, 200);
    });
    // this.initPage()
  },
  created() {
    
  },
  computed: {
    statusHeight() {
      return this.$store.state.statusHeight;
    },
    Init() {
      return this.$store.state.refreshPage;
    },
  },
  watch: {
    //  refreshPage(oldValue,newValue){
    //    if(newValue){
    //     //  this.initPage()
    //    }
    //  }
  },
  methods: {
    initPage() {
      if (this.$route.query.id && this.num==1) {
      this.toLearn(this.$route.query.id);
      this.num++
    }
      this.current = 1;
      this.list = [];
      this.init = true;
      this.getCourseList();
    },

    //获取列表
    getCourseList() {
      // Toast(this.lit)
      // this.lit++
      http
        .getClassCourse({ current: this.current, size: this.size, type: 3 })
        .then((res) => {
          setTimeout(() => {
            if (res.recommendedCourseList.length > 0) {
              if (this.refreshing || this.init) {
                this.list = [...res.recommendedCourseList];
                this.refreshing = false;
                this.init = false;
              } else {
                this.list = [...this.list, ...res.recommendedCourseList];
              }
              this.loading = false;
              this.current++;
              if (res.recommendedCourseList.length < 20) {
                this.finished = true;
              }
            } else {
              this.finished = true;
              this.current--;
            }
          }, 200);
          this.courseObj = res;
          this.alreadyBoughtCourseList = res.alreadyBoughtCourseList;
        });
    },

    toLearn(id) {
      this.$router.push({
        path: "/SpeedStudyIntro",
        query: { id, type: 3 },
      }).then(res=>window.PushToken(this.$store.state.token));
    },
    //页面滚动
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let oneHeight = this.$refs.scrollOne.offsetHeight;
      //
      // console.log(scrollTop);

      if (scrollTop > oneHeight) {
        //这是滑动到scrollTwo的距离要做的操作
        this.showTitle = true;
      } else {
        this.showTitle = false;
      }
    },
    onLoad() {
      if (this.refreshing) {
      } else {
      }

      this.getCourseList();
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.current = 1;
      this.onLoad();
    },
    toBuyedPage() {
      this.$router.push({
        path: "/BuyedCourse",
      });
    },
    toNative() {
      http.guitarAppListener("backToNative", {});
    },
  },
};
</script>

<style lang="less" scoped>
.speedStudyPage {
  position: relative;
  min-height: 100vh;
}
.selfStudy {
  display: flex;
  flex-direction: column;
  position: relative;

  .bg {
    width: 100%;
    height: 174px;
    background: url("../../assets/images/homeWorkBg.png");
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    img {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 14px;
      left: 16px;
    }
    .courseType {
      width: calc(100% - 32px);
      margin: 0 auto;
      margin-top: 76px;
      display: flex;
      justify-content: space-between;
      align-items: "center";
      .typeInfo {
        .typeTitle {
          font-size: 24px;

          font-weight: bold;
          color: #fff;
        }
        .typeword {
          font-size: 13px;
          color: #cacacc;
          margin-top: 4px;
        }
      }
      .countWord {
        font-size: 13px;
        color: #cacacc;
        margin-top: 2px;
        margin-bottom: 6px;
      }
    }
  }

  .content {
    width: 100%;
    flex: 1;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    margin-top: -18px;
    position: relative;
    z-index: 99;
    padding: 0 16px;
    box-sizing: border-box;

    .areadlyBuy {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 24px;
      img {
        width: 7px;
        height: 16px;
      }
      .buyedTitle {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .buyedList {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .notHave {
        width: 148px;
        height: 76px;
        margin-top: 8px;
      }
      span {
        font-size: 13px;
        color: rgba(34, 32, 48, 0.45);
        display: inline-block;
        margin-top: 8px;
      }
    }
    .buyedList2 {
      margin-top: 8px;
      display: flex;
      overflow-y: scroll;
      .buyedCourse {
        margin-right: 12px;
        img {
          width: 140px;
          height: 80px;
          border-radius: 4px;
          object-fit: cover;
        }
        div {
          // margin-top: 4px;
          font-size: 13px;
          font-weight: 600;
          color: #222030;
        }
      }
    }

    .contentTitle {
      margin-top: 24px;
      font-size: 20px;
      font-weight: bold;
    }
    .intro {
      color: rgba(34, 32, 48, 0.65);
      font-size: 13px;
    }

    .courseList {
      margin-top: 12px;
      .courseCard {
        display: flex;
        width: 100%;
        background: #f6f6f6;
        border-radius: 6px 6px 6px 6px;
        overflow: hidden;
        height: 100px;
        margin-bottom: 8px;

        .coursePoster {
          img {
            width: 100px;
            object-fit: cover;
            height: 100px;
          }
        }
        .cardRight {
          margin-left: 8px;
          flex: 1;
          padding-right: 16px;
          box-sizing: border-box;
        }
        .courseTitle {
          color: #222030;
          font-size: 15px;
          font-weight: bold;
          margin-top: 12px;
        }
        .learnNum {
          font-size: 12px;
          color: rgba(34, 32, 48, 0.45);
          margin-top: 4px;
        }
        .courseBt {
          display: flex;
          justify-content: space-between;
          //   align-items: center;
          //   margin-top: 6px;

          .teacherInfo {
            display: flex;
            align-items: center;
            margin-top: 17px;
            img {
              width: 20px;
              height: 20px;
              object-fit: cover;
              border-radius: 50%;
            }
            .teachername {
              font-size: 12px;
              color: rgba(34, 32, 48, 0.65);
            }
          }

          .learnBt {
            width: 72px;
            margin-top: 6px;
            height: 28px;
            background: linear-gradient(135deg, #ff7337 0%, #fc541e);
            border-radius: 6px;
            font-size: 13px;
            color: #ffffff;
            text-align: center;
            line-height: 29px;
          }
        }
      }
    }
  }
}
</style>

